import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

export const enterpriseValueListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    fontWeight: 700,
    padding: '4.5px 12px',
  }),
};

export const financialStatementPeriodsListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    fontWeight: 700,
    padding: '4.8px 12px',
  }),
};

export const EBITDAListStyles: StylesConfig<OptionType, false> = {
  option: styles => ({
    ...styles,
    fontWeight: 700,
    padding: '4.5px 12px',
  }),
};
